<template>
    <div class="col-md-6">
        <label class="attribute-label" :for="discountId">Discount</label>

        <div class="input-group width-100">
            <input type="number" step="0.01" :name="discountName" :id="discountId" class="form-control price-new-inputs"
                   v-model="numberValue">
            <span class="input-group-addon input-group-addon-new-design-right width-10">
                <select :id="discountTypeId" v-model="attributeValueId" :name="discountTypeName" class="form-control"
                        style="border: none;background-color: white;padding: 0px">
                    <option :value="attributeValue.attribute_value_id"
                            v-for="(attributeValue, index) of discountType.attribute_values" :key="index">
                        {{ attributeValue.attribute_value }}
                    </option>
                </select>
            </span>
        </div>
    </div>
</template>

<script>

const SERVICE_DISCOUNT = 11;
const SERVICE_DISCOUNT_TYPE = 14;
import { EventBus } from "@/events/event-bus";
export default {
    name: "DiscountAttribute",
    props: {
      value:{
        type: Number
      },
        discountAttributes: {
            type: Array,
            required: true
        },
        service: {
            type: Object,
            required: true
        },
        subtotalBeforeDiscount: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            numberValue: this.value,
          attributeValueId: 5440
        }
    },
    computed: {
        discount() {
            return this.discountAttributes.find(attribute => this.isDiscount(attribute));
        },
        /**
         * get discount attribute input id
         * @returns {string}
         */
        discountId() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.discount.service_id}${this.discount.attribute_id}_${this.service.clone}`;
            }
            if (typeof this.discount != "undefined"  ){
            return `attribute_${this.discount.service_id}${this.discount.attribute_id}`;
            }
        },
        /**
         * get discount attribute input name
         * @returns {string}
         */
        discountName() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.discount.service_id}${this.discount.attribute_id}_${this.service.clone}`;
            }
            if (typeof this.discount != "undefined"   ){
            return `attribute_${this.discount.service_id}${this.discount.attribute_id}`;
            }
        },
        discountType() {
            return this.discountAttributes.find(attribute => this.isDiscountType(attribute));
        },
        /**
         * get discount type attribute input id
         * @returns {string}
         */
        discountTypeId() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.discountType.service_id}${this.discountType.attribute_id}_${this.service.clone}`;
            }
            if (typeof this.discountType != "undefined"   ){
            return `attribute_${this.discountType.service_id}${this.discountType.attribute_id}`;
            }
        },
        /**
         * get discount type attribute input name
         * @returns {string}
         */
        discountTypeName() {
            if (parseInt(this.service.clone)) {
                return `attribute_${this.discountType.service_id}${this.discountType.attribute_id}_${this.service.clone}`;
            }
            if (typeof this.discountType != "undefined"   ){
            return `attribute_${this.discountType.service_id}${this.discountType.attribute_id}`;
            }
        },
      discountValue() {
        if (this.selectedAttributeValue === "%") {
          return this.subtotalBeforeDiscount * (this.numberValue / 100)
        }
        return this.numberValue
      },
      selectedAttributeValue() {
        // Returns the actual attribute_value based on the selected attributeValueId
        const selected = this.discountType?.attribute_values?.find(attr => attr.attribute_value_id === this.attributeValueId);
        return selected?.attribute_value || null;
      }
    },
    mounted() {
        this.setDefaultValue()
        EventBus.$on("discountChanged", (newDiscount,discountTypeStr="") => {
          if(discountTypeStr)
            this.setAttributeIdByStr(discountTypeStr)
          this.numberValue = newDiscount
        })
    },
    methods: {
        isDiscount(attribute) {
            return attribute.attribute_type_id === SERVICE_DISCOUNT;
        },
        isDiscountType(attribute) {
            return attribute.attribute_type_id === SERVICE_DISCOUNT_TYPE;
        },
      setDefaultValue() {
        if (typeof this.discountType !== "undefined" && this.discountType.service_attribute_value) {
          this.attributeValueId = +this.discountType.service_attribute_value;
        }
        if (typeof this.discount !== "undefined" && this.discount.service_attribute_value) {
          this.numberValue = this.discount.service_attribute_value;
        }
      },
      setAttributeIdByStr(discountTypeStr){
        let attributeValue;
        if (discountTypeStr === "per_unit" || discountTypeStr === "one_off") {
          attributeValue = this.discountType.attribute_values.find(attribute => attribute.attribute_value === '$');
        } else if (discountTypeStr === "percent") {
          attributeValue = this.discountType.attribute_values.find(attribute => attribute.attribute_value === '%');
        }
        // Check if attributeValue is defined and has properties
        if (attributeValue && Object.entries(attributeValue).length > 0) {
          this.attributeValueId = attributeValue.attribute_value_id;
        }
      }
    },
    watch: {
        discountValue(value) {
            this.$emit('input', value)
        }
    }
}
</script>

<style scoped>

</style>